
<template>
    <div id="News" class="wrap">
        <div class="news">
        <div class="title">
            <h2>News</h2>
        </div>  
        <p>SEVS 13th 정기전시 ‘겹물결’</p>
        <ul>
            <b-button variant="outline-dark">
                <li>
                    <a href="http://www.ifm.kr/news/307916" target="_blank">‘겹물결: Living Fragment' 전시회...포스트 코로나를 위한 성찰</a>
                </li>
            </b-button>
            <b-button variant="outline-dark">
                <li>
                    <a href="http://www.incheonilbo.com/news/articleView.html?idxno=1093010" target="_blank">뉴미디어 작가들, 더 나은 미래 향해 손을 뻗다</a>
                </li>
            </b-button>
            <b-button variant="outline-dark">
                <li>
                    <a href="http://www.kyeongin.com/main/view.php?key=20210503010000510" target="_blank">젊은 작가들의 '변화의 물결'…인천 코스모40서 9일까지 뉴미디어展</a>
                </li>
            </b-button>
            <b-button variant="outline-dark">
                <li>
                    <a href="http://www.kihoilbo.co.kr/news/articleView.html?idxno=925145" target="_blank">‘겹 물결 (Living Fragmant), 새로운 일상을 꿈꾸며’ 뉴미디어 전시회 개최</a>
                </li>
            </b-button>
        </ul>
        <p>SEVS 14th 정기전시 ‘창신절벽예술제’</p>
        <ul>
            <b-button variant="outline-dark">
                <li>
                    <a href="https://www.jungle.co.kr/magazine/203424" target="_blank">절벽을 품고 있는 마을, 예술로 재생하다 ‘창신 절벽 예술제’ </a>
                </li>
            </b-button>
            <b-button variant="outline-dark">
                <li>
                    <a href="http://news.heraldcorp.com/view.php?ud=20210913000486" target="_blank">문화·예술 색칠한 흥인지문 옆마을, 창신절벽예술제 개막</a>
                </li>
            </b-button>
            <b-button variant="outline-dark">
                <li>
                    <a href="https://newsis.com/view/?id=NISX20210913_0001581711&cID=10701&pID=10700" target="_blank">절벽을 품고 있는 마을 아시나요?...'창신절벽예술제'</a>
                </li>
            </b-button>
        </ul>
        </div>
    </div>
</template>

<script>
import { list } from '@/mixins/list.js';

export default {
    mixins:[list],

    data(){
        return{

        }
    },
    methods:{
        exhibition(){ //지난 전시
            console.log(list)
        }
    }
}
</script>


<style lang="scss">
#News{
    .news {padding-bottom: 80px;
        .title{margin: 90px 0 0 0; }
        p{font-size: 22px; font-weight: 500; margin: 50px 0px 20px 0px;}
        button{width:100%; border-radius:10px; border:2px solid #eee; margin-bottom:20px; padding:5px;}
        li {width:100%; border-radius:5px; padding:15px; border:2px solid #eee; font-size: 20px; box-shadow: 1px 1px 5px 4px #adafae;
            a {display: block; width:100%; text-align: initial;}
        }
    }
}
@media(max-width:767px) {
    #News{
        .news{padding-bottom: 50px; padding-left: 10px; padding-right: 10px;
            .title{margin: 10px 0 0 10px; } 

            h2{margin-bottom: 25px;}
            button{margin-bottom: 15px;}
            p{margin-top: 10px; font-size: 1rem;}
            li{font-size: 0.9rem; padding: 5px;}
        }
    }
}
</style>